export default {"src":"/_next/static/media/sport.6ab157e4.svg","height":25,"width":26,"blurWidth":0,"blurHeight":0};